declare var XenaDS: any;

/**
 * Utility for handling Xena DS confirm
 */
export class TranslateModalConfirm {

  /**
   * Open confirm
   */
    public static open(): Promise<boolean> {
      return XenaDS.confirm(
        /* message     */ $localize`:@@translateApp_modal_confirmMessage:Your updated translation will be lost. Are you sure that you want to proceed?`,
        /* type        */ 'danger',
        /* title       */ $localize`:@@translateApp_modal_confirmTitle:Discard changes?`,
        /* confirmText */ $localize`:@@translateApp_modal_confirmConfirmBtnText:Proceed`);
    }

  }
